import { Component, OnInit, inject } from '@angular/core';
import { RightBridgeApiService } from '../../../app/services/right-bridge-api.service';
import { AdminService } from '../admin.service';
import { CheckSolutionsResponse } from '../../models/admin-models';

@Component({
  selector: 'app-versions',
  templateUrl: './versions.component.html',
  styleUrls: ['./versions.component.scss'],
  imports: [],
})
export class VersionsComponent implements OnInit {
  private rbs = inject(RightBridgeApiService);
  private admnSrvc = inject(AdminService);

  SolutionsData = {};

  ngOnInit(): void {
    this.admnSrvc
      .getCheckSolutions()
      .subscribe((x: CheckSolutionsResponse) => (this.SolutionsData = x));
  }

  /* parseVersions() {
    const bla = this.SolutionsData['Server']['Solutions'].forEach(srn => {
      srn.forEach(rbs => {
        srn[rbs]['UIConfigs'].forEach(uic => {
          return `${uic['Type']}: ${uic['Version']}`
        })
      })
    })
  } */
}
